<template>
  <div class="guide">
    <div class="guide-step-1" v-if="step === 1">
      <div class="upgrade-notes">
        <i class="el-icon-close" @click="handleClose"></i>
        <div class="upgrade-notes-title">
          <svg class="icon">
            <use xlink:href="#icon-upgrade"></use>
          </svg>控制台新版本升级
        </div>
        <div class="upgrade-notes-desc">
          <p><span>全新的控制台操作界面，服务管理更加便捷</span></p>
          <p><span>更详尽的业务内容管理，更全面的信息展示</span></p>
          <p><span>APPID再无操作系统平台限制，多平台共享</span></p>
        </div>
        <div class="next-btn" @click="step = 2">马上体验新版控制台</div>
      </div>
    </div>
    <div class="guide-step-2" v-if="step === 2">
      <div class="sidebar-mask"></div>
      <div class="next-card">
        <p>服务管理按产品服务划分，点击直<br/>接使用，不再需要开通应用了。</p>
        <div class="next-btn" @click="step = 3">
          下一步
        </div>
      </div>
      <i class="el-icon-close" @click="handleClose"></i>
    </div>
    <div class="guide-step-3" v-if="step === 3">
      <div class="navbar-mask"></div>
      <div class="next-card">
        <p>订单管理、工单、消息、个人<br/>资料页的入口，搬到这里啦。</p>
        <div class="next-btn" @click="step = 4">
          下一步
        </div>
      </div>
      <i class="el-icon-close" @click="handleClose"></i>
    </div>
    <div class="guide-step-4" v-if="step === 4">
      <div class="service-mask"></div>
      <div class="next-card">
        <p>新版本服务管理页面布局直观，操<br/>作便捷，内容展示一目了然。</p>
        <div class="next-btn" @click="step = 5">
          下一步
        </div>
      </div>
      <i class="el-icon-close" @click="handleClose"></i>
    </div>
    <div class="guide-step-5" v-if="step === 5">
      <div class="map-mask"></div>
      <div class="next-card">
        <p>点击这里的返回按钮，可以返回应<br/>用列表。</p>
        <div class="next-btn" @click="handleClose">
          知道了
        </div>
      </div>
      <i class="el-icon-close" @click="handleClose"></i>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Guide',
  data() {
    return {
      step: 1
    }
  },
  mounted() {
    localStorage.removeItem('__hw')
  },
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scope>
@import '~styl/mixins'
.guide
  min-width: 9.1rem
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  z-index 99999
  > div
    width 100%
    height 100%
  .next-btn
    display inline-block
    height 30px
    line-height 30px
    font-size 14px
    background-color #f6faff
    color #20a0ff
    border 1px solid #20a0ff
    border-radius 4px
    transition background-color .3s, color .3s
    cursor pointer
    &:hover
      background-color #20a0ff
      color #fff
  .next-card
    display inline-block
    padding 25px
    border-radius 6px
    background-color #f5f5f5
    text-align center
    position absolute
    box-shadow 0px 0 5px rgba(#000, .4)
    p
      font-size 16px
      line-height 30px
      text-align left
    .next-btn
      margin-top 20px
      width 110px
  .guide-step-2, .guide-step-3, .guide-step-4, .guide-step-5
    .el-icon-close
      position absolute
      right 50px
      top 90px
      font-size 24px
      color #fff
      font-weight bold
      cursor pointer
  .guide-step-1
    background-color rgba(#000, .4)
    .upgrade-notes
      position absolute
      top 150%
      left 50%
      transform translate(-50%, -50%)
      width 5.74rem
      padding .5rem 0
      background-color #fff
      border-radius 5px
      box-shadow 0px 0 5px rgba(#000, .4)
      text-align center
      animation fade-in .5s ease-in-out .1s 1
      animation-fill-mode forwards
      .upgrade-notes-title
        display flex
        align-items center
        justify-content center
        font-size 32px
        font-weight bold 
        color #797979
        .icon
          width 50px
          height 50px
          margin-right 20px
      .upgrade-notes-desc
        margin 20px 0 30px
        font-size 16px
        text-align center
        p
          line-height 40px
          span 
            padding-left 10px
            position relative
            &::before
              position absolute
              left 0
              top 50%
              content ''
              margin-top -2px
              width 4px
              height 4px
              border-radius 2px
              background-color #333
      .el-icon-close
        position absolute
        right 15px
        top 15px
        cursor pointer
      .next-btn
        height 54px
        line-height 54px
        font-size 18px
        padding 0 35px
        font-weight bold
  .guide-step-2
    .sidebar-mask
      position absolute
      left 0
      top 140px
      bottom 0
      width 210px
      border 2px dashed #aeaeae
      box-shadow 0px 0px 0px 9000px rgba(#000, .4)
    .next-card
      left 230px
      top 205px
  .guide-step-3
    .navbar-mask
      position absolute
      right 0
      top 0
      width 640px
      height 60px
      border 2px dashed #aeaeae
      box-shadow 0px 0px 0px 9000px rgba(#000, .4)
    .next-card
      right 230px
      top 80px
  .guide-step-4
    .service-mask
      position absolute
      left 210px
      top 60px
      right 0
      bottom 0
      border 2px dashed #aeaeae
      box-shadow 0px 0px 0px 9000px rgba(#000, .4)
    .next-card
      left 230px
      top 80px
    .el-icon-close
      right 50px
      top 20px
  .guide-step-5
    .map-mask
      position absolute
      left 0
      top 60px
      width 210px
      height 80px
      border 2px dashed #aeaeae
      box-shadow 0px 0px 0px 9000px rgba(#000, .4)
    .next-card
      left 20px
      top 160px
  @keyframes fade-in {
    0% {
      top: 150%
    }
    100% {
      top: 50%
    }
  }
</style>



// WEBPACK FOOTER //
// app/components/Guide/index.vue